import { AppThunk } from '../../../store/rootReducer';
import * as AnnotationTaskClient from '../clients/annotation-task.client';
import * as adminActions from '../actions/admin.actions';

export const loadAnnotatorsList =
  (withAnnotationTasks: boolean): AppThunk =>
  async (dispatch) => {
    try {
      const annotatorsList = await AnnotationTaskClient.getAllAnnotators(
        withAnnotationTasks,
      );
      if (annotatorsList) {
        dispatch(
          adminActions.setAnnotatorsList({
            annotatorsList,
          }),
        );
      }
    } catch (error) {
      console.error('Error to load annotators list:', error);
    }
  };
